export default class PurchaseConfirmLayer {
  constructor() {
    this.welContainer = $('#_layerContainer');
    this.sWrapper = '_purchaseConfirmLayer';
    this.render();
    
    const viewAreaCode = TMON.htCommonStaticInfo.junsi.pishingPopupCfBannerFromJunsi;
    const { viewAreaGetByDealNo } = TMON.oApp.htStorage;
    const viewAreaList = viewAreaGetByDealNo.data;
    if (!viewAreaList || !viewAreaList.length) {
      return;
    }
    const viewAreaData = viewAreaList.filter((el) => el.viewAreaCode === viewAreaCode);

    $(".popup_phishing .popup_banner").junsi({
      viewContentsAreaCode: viewAreaCode,
      afterRender: (wel) => {
        const junsiArea = wel.find(
          `[data-vwa-code=${viewAreaCode}]`
        );
        const items = $(junsiArea).find(".vwa_item");
        if (items.length === 0) {
          wel.find('.vwa_info').remove();
          return;
        }
        items.each((index, el) => {
          $(el).find("a").attr("target", "_blank");
          $(el)
            .attr("data-tlarea", "DDAB")
            .attr("data-tlord", index + 1)
            .attr(
              "data-tldimension",
              `73:${$(el)
                .find("a")
                .attr("href")}`
            );
        });
        this.setRollingBanner(wel);
      },
      htData: { data: viewAreaData }
    });
  }

  onClose = () => {
    TMON.oApp.setStorage('validateBuyNow', {
      type: 'default',
    });
  };

  setRollingBanner(wel) {
    const vwaInfo = wel.find(".vwa_info:first");
    const vwaItems = vwaInfo.find(".vwa_item");
    const images = wel.find("img");

    // 이미지가 없을 경우 영역 자체를 제거
    if (images.length === 0) {
      wel.remove();
      return false;
    }
    // 랜덤 셔플
    let curBannerIndex = Math.floor(Math.random() * images.length);

    const showBanner = () => {
      vwaItems
        .stop()
        .css("position", "absolute")
        .fadeOut();
      vwaItems
        .eq(curBannerIndex)
        .stop()
        .css("position", "relative")
        .fadeIn();
    };

    const nextBanner = () => {
      if (curBannerIndex < vwaItems.length - 1) {
        curBannerIndex += 1;
      } else {
        curBannerIndex = 0;
      }
      showBanner();
    };

    const startTimer = () => {
      const timerId = wel.data("timerId");
      if (timerId) {
        clearInterval(timerId);
      }

      const tempTimerId = setInterval(() => {
        nextBanner();
      }, 2000);
      wel.data("timerId", tempTimerId);
    };

    if (!vwaItems.length) {
      return false;
    }

    vwaItems.css("position", "absolute").hide();
    vwaItems
      .eq(curBannerIndex)
      .css("position", "relative")
      .show();

    if (vwaItems.length > 1) {
      showBanner();
      startTimer();
    }

    return true;
  }

  render = () => {
    const sHtml = 
      `<div class="popup popup_phishing cf popup_layer">
        <section id="${this.sWrapper}" class="cf_cont" data-layerId="PurchaseConfirmLayer">
          <header class="popup_header">
            <h3 class="popup_header_title">구매 전 꼭 확인해 주세요.</h3>
            <button type="button" class="popup_header_close" aria-label="팝업닫기" data-role="close">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                <path fill="#30343B" fill-rule="evenodd" d="M0 0h.87v.87H0V0zm.87.87h.87v.87H.87V.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87h.869v.869h-.87v-.87zm.869.869h.87v.87h-.87v-.87zm.87.87H20V20h-.87v-.87zM20 0v.87h-.87V0H20zm-.87.87v.87h-.87V.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-1.739 1.739v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.87h-.87v-.87h.87zm-.87.87v.869h-.869v-.87h.87zm-.869.869v.87h-.87v-.87h.87zm-.87.87v.869H1.74v-.87h.87zm-.869.869v.87H.87v-.87h.87zm-.87.87V20H0v-.87h.87z"></path>
              </svg>
            </button>
          </header>
          <div class="popup_contents">
            <article class="popup_inner">
              <p class="popup_definition_desc">
                  가족, 지인을 사칭하여 문자, 카카오톡 등을 이용해 상품권 대리 구매를 요청하는 피해가 발생하고 있습니다.<br>
                  본인이 사용이 아닌 <span class="text_color1">타인의 요청으로 구매하시는 경우 반드시 전화로 본인확인</span>을 해 주시기 바랍니다.
              </p>
            </article>
            <div class="popup_buttons">
              <button type="button" class="popup_button type01" data-role="close">
                확인
              </button>
            </div>
          </div>
        </section>
        <!-- 광고 이미지 -->
        <div class="popup_banner">
        </div>
      </div>`;

    this.welContainer.append(sHtml);
  };

  open = () => {
    if (TMON.oApp.sPlatform === 'PW') {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
        bSetHash: true,
        bUseHistorybackOnClose: true,
        bShowDimmed: true,
      });
    } else {
      TMON.oApp.oUtil.handleOpenLayer({
        welTargetLayer: $(`#${this.sWrapper}`),
      });
      $('.popup_phishing').show();
    }
  };
}
